// extracted by mini-css-extract-plugin
export default {"collapseToggle":"ToggleCollapse_collapseToggle__qbeQF","svgContainer":"ToggleCollapse_svgContainer__6RkxQ","isCollapse":"ToggleCollapse_isCollapse__wip3i"};